/**
 * Map stored birth date strings (DD/MM/YYYY, YYYY-MM-DD, etc.) to value for <input type="date">.
 * Returns '' when the value cannot be parsed (e.g. junk) so the picker starts empty.
 */
export function birthDateToHtmlInputValue(raw) {
  if (raw == null) return '';
  const s = String(raw).trim();
  if (!s) return '';

  // Plain YYYY-MM-DD or start of ISO datetime (e.g. from API)
  const iso = /^(\d{4})-(\d{2})-(\d{2})(?:[T\s]|$)/.exec(s);
  if (iso) {
    const y = Number(iso[1]);
    const m = Number(iso[2]);
    const d = Number(iso[3]);
    const dt = new Date(y, m - 1, d);
    if (dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d) {
      return `${iso[1]}-${iso[2]}-${iso[3]}`;
    }
    return '';
  }

  const dmy = /^(\d{1,2})[/.\-](\d{1,2})[/.\-](\d{4})$/.exec(s);
  if (dmy) {
    const day = parseInt(dmy[1], 10);
    const month = parseInt(dmy[2], 10);
    const year = parseInt(dmy[3], 10);
    const dt = new Date(year, month - 1, day);
    if (dt.getFullYear() === year && dt.getMonth() === month - 1 && dt.getDate() === day) {
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    }
  }

  return '';
}

/** Latest calendar date allowed for 18+ applicants (local midnight). */
export function maxBirthDateIsoForAdult() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setFullYear(d.getFullYear() - 18);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
